import axios from "axios";

export const chatApi = axios.create({
  baseURL:
    process.env.REACT_APP_AI_DASHBOARD_API_URL || "http://localhost:4000",
});
